





















import Vue from 'vue'
import { IDevice, IVW } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { generalDialogMixin, elementWidth } from '@/mixins'
import easyapi from '@/easyapi'
import { deepCopy, magicCode2Text, rotateFlipToIgClass } from '@/utils'
import VwResizePreview from '@/components/VwResizePreview.vue'
import IgIcon from '@/components/IgIcon.vue'
import { VW_MAX_COLUMNS, VW_MAX_ROWS } from '@/vw_algorithm'
import { ApiVwBezel, RotateFlip, ApiVwTx } from '@/types/api'
import { PropValidator } from 'vue/types/options'

const ROTATE_FLIP_ENUMS = [
  RotateFlip.normal,
  RotateFlip.vert,
  RotateFlip.hori,
  RotateFlip.rotate90,
  RotateFlip.rotate180,
  RotateFlip.rotate270,
  // RotateFlip.rotate90_hori,  // Fucking buggy
  // RotateFlip.rotate270_hori,  // Fucking buggy
]

export default mixins(generalDialogMixin, elementWidth).extend({
  components: {
    VwResizePreview,
    IgIcon
  },
  props: {
    show: {
      type: Boolean
    },
    initialValue: { } as PropValidator<RotateFlip>
  },
  data (): {
    imgWidth: number,
    rotateFlip: RotateFlip,
    rotateFlipToIgClass: typeof rotateFlipToIgClass,
    ROTATE_FLIP_ENUMS: typeof ROTATE_FLIP_ENUMS,
  } {
    return {
      imgWidth: 0,
      rotateFlip: RotateFlip.normal,
      rotateFlipToIgClass,
      ROTATE_FLIP_ENUMS
    }
  },
  computed: {
  },
  methods: {
    async apply () {
      this.$emit('apply', this.rotateFlip)
      this.closeThisDialog()
    }
  },
  watch: {
    show (nv: boolean) {
      if (nv) {
        if (this.initialValue === undefined) {
          console.warn('[To Developer] Please provide a RX as initial value (:initialValue="aRx") to RotateFlip')
        } else {
          this.rotateFlip = this.initialValue
        }
      }
    }
  },
  mounted () {
    this.watchElementWidth('imgContainer', ['show'])
  }
})
